module.exports = __webpack_public_path__ + "static/media/white_red2.d25bfa8e.jpg";